<template>
  <div class="text-left">
    <GoBackButton />
    <div class="bg-card">
      <h2>{{ $t('pages.killer-questions-templates.add-question.title', 'New Killer Question') }}</h2>
      <div class="px-4">
        <div class="subtext mb-2">
          {{ $t('pages.killer-questions-templates.add-question.subtitle') }}
        </div>
        <div class="mb-4">
          <FoldersTree
            :folders-data="killerqFoldersSelect"
            :show-questions="true"
            :is-expanded="false"
            :is-folder-select="false"
            :is-question-select="true"
            :selected-question="selectedQuestion"
            :show-questions-count="true"
            @question-select="selectQuestion"
          />
        </div>
        <div class="row mb-4 justify-content-between">
          <div class="col-12 col-lg-7">
            <KillerQuestion
              ref="killerQuestion"
              :question-template="selectedQuestion"
            />
          </div>
          <div class="col-12 col-lg-5">
            <ul
              style="background: white; font-size: 0.85rem"
              class="px-5 py-3"
            >
              <li class="mb-3">
                {{ $t('pages.killer-questions-templates.add-question.rule-1') }}
              </li>
              <li class="mb-3">
                {{ $t('pages.killer-questions-templates.add-question.rule-2') }}
              </li>
              <li>
                {{ $t('pages.killer-questions-templates.add-question.rule-3') }}
              </li>
            </ul>
          </div>
        </div>
        <div class="mb-4">
          <h3>{{ $t('pages.killer-questions-templates.add-question.save-in-folder', 'Save to folder') }}</h3>
          <div class="mb-2 subtext">
            {{ $t('pages.killer-questions-templates.add-question.save-in-folder-subtitle', 'Select the location of the new Killer Question template:') }}
          </div>
          <b-alert
            variant="danger"
            :show="isSaveFolderSelected"
          >
            <font-awesome-icon
              icon="exclamation-triangle"
              class="danger-icon m-auto"
            />
            {{ $t('pages.killer-questions-templates.add-question.must-select-folder', 'You must select a folder!') }}
          </b-alert>
          <b-form-checkbox
            id="showQuestions-checkbox"
            v-model="isShowQuestions"
            size="sm"
          >
            {{ $t('pages.killer-questions-templates.add-question.view-questions', 'See the folder questions') }}
          </b-form-checkbox>
          <FoldersTree
            :folders-data="killerqFolders"
            :show-questions="isShowQuestions"
            :is-expanded="true"
            :is-folder-select="true"
            :selected-folder="selectedSaveFolder"
            @node-click="selectSaveFolder"
          />
        </div>
      </div>
      <div class="row justify-content-center mb-2">
        <b-button
          variant="success"
          size="sm"
          class="mr-1"
          @click="saveQuestion()"
        >
          {{ $t('generic.save') }}
        </b-button>
        <b-button
          variant="secondary"
          size="sm"
          @click="$router.go(-1)"
        >
          {{ $t('generic.cancel') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';
import FoldersTree from '@/components/jobs/killerQuestionsTemplates/FoldersTree';
import KillerQuestion from '@/components/jobs/blocks/KillerQuestion.vue';

export default {
  components: {
    GoBackButton,
    FoldersTree,
    KillerQuestion
  },
  data() {
    return {
      killerqFolders: null,
      killerqFoldersSelect: null,
      selectedSaveFolder: {
        title: ""
      },
      selectedQuestion: {
        text: ""
      },
      isShowQuestions: false,
      selectedQuestionObj: null,
      init: true
    }
  },
  computed: {
    isSaveFolderSelected() {
      return !this.init && this.selectedSaveFolder.title === "";
    },
    isAdmin() {
      return this.$hasRole(['admin']);
    }
  },
  mounted() {
    if(this.isAdmin) {
      this.getAll();
    } else {
      this.getAll();
      this.getUserAdmin();
    }
  },
  methods: {
    getAll() {
      let url = this.isAdmin ? '/killer-questions-templates/all-admin'
          : '/killer-questions-templates/all-user';

      this.axios.get(url)
        .then( response => {
          this.killerqFolders = response.data;
          if(this.isAdmin) {
            this.killerqFoldersSelect = this.killerqFolders;
          }
        });
    },
    getUserAdmin() {
      this.axios.get('/killer-questions-templates/all-user-admin')
        .then( response => {
          this.killerqFoldersSelect = response.data;
        });
    },
    selectSaveFolder(node) {
      this.selectedSaveFolder = node;
    },
    validate() {
      if(this.selectedSaveFolder.title === "") {
        this.$toastNotification('danger', '', this.$t('pages.killer-questions-templates.add-question.select-save-folder', "Must select save folder"));
        return false;
      } else {
        return true;
      }
    },
    saveQuestion() {
      this.init = false;
      let killerQuestion = this.$refs.killerQuestion;
      if(killerQuestion.validateAnswer()) {
        let questionData = this.$refs.killerQuestion.questionObj;
        if(this.validate(questionData)) {
          delete questionData.questionObj;
          let data = {
            questionData: questionData,
            saveFolder: this.selectedSaveFolder.id
          }

          this.axios.post('/killer-questions-templates/add-question', data)
            .then( () => {
              this.$router.push({ name: 'manage-killerq-templates' });
            })
            .catch();
        }
      }
    },
    selectQuestion(question) {
      if(this.selectedQuestion.text == question.text) {
        this.selectedQuestion = {
          text: ""
        }
      } else {
        this.selectedQuestion = question;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .subtext {
    font-size: 0.85rem;
  }
</style>
